module.exports = __webpack_public_path__ + "static/media/sajeenthiran.503f30af.jpeg";